import React from "react";
import { makeStyles } from "@material-ui/styles";
import iconImage from "./profile-action-icon-compare-locked.svg";

const useStylesProfileActionButtonCompare = makeStyles((theme) => {
  console.log(theme);
  return {
  };
});

const ProfileActionButtonCompare = () => {
  const classes = useStylesProfileActionButtonCompare();
  return (
    <div>
    <img src={iconImage} />
    </div>
  );
};

export default ProfileActionButtonCompare;